Ext.define('SA.view.Alert', {
    alias: 'widget.alert',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    baseCls: 'sa-alert',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-alert-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-alert-title',
                    itemId: 'title'
                }, {
                    xtype: 'close-button',
                    closeAction: 'onClose'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-alert-body',
            itemId: 'message'
        }, {
            xtype: 'simple-container',
            cls: 'sa-alert-footer',

            items: [
                {
                    xtype: 'sa-button',
                    text: 'OK',

                    handler() {
                        this.up('alert').onClose();
                    }
                }
            ]
        }
    ],

    initComponent() {
        var htmlEncode = Ext.String.htmlEncode,
            title = htmlEncode(this.title),
            message = Ext.util.Format.nl2br(htmlEncode(this.message));

        this.callParent();

        this.down('#title').update(title);
        this.down('#message').update(message);
    },

    onClose() {
        Ext.callback(this.handler, this.scope || this);

        this.destroy();
    }
});
